export const FORM_ROOT_CLASS = "form-root";
export const FORM_ROOT_DATA_ATTR = "data-form-root";
export const FORM_DIRTY_DATA_ATTR = "data-form-dirty";
const FORM_ROOT_SELECTOR = `.${FORM_ROOT_CLASS}, [${FORM_ROOT_DATA_ATTR}]`;

export const hasDirtyFormInContainer = (container: HTMLElement): boolean => {
    const formRoot = container.querySelector<HTMLElement>(FORM_ROOT_SELECTOR);
    return formRoot?.getAttribute(FORM_DIRTY_DATA_ATTR) === "true";
};
